import React, { useState } from 'react';
import styled from 'styled-components';
import { isFunction, isString } from 'lodash';

const Container = styled.div`
  max-height: ${({ visible }) => visible? "69px" : "0px"};

  text-align: center;
  background-color: #40a03f;
  color: #eee;

  transition: max-height 1s;
  overflow: hidden;

  & > * {
    margin: 9px 3px !important;
  }
`;

export default function NotifyBox({ children, style, className, control }) {

  const [ isVisible, setVisible ] = useState(false);

  if (isFunction(control)) {
    const controller = {
      show: () => {
        setVisible(true);
      },
      hide: () => {
        setVisible(false);
      }
    };

    control(controller);
  }

  return(<>
    <Container className={className} style={style} visible={isVisible} >
      {
        isString(children)
        ? <p>{ children }</p>
        : children
      }
    </Container>
  </>);
}